module.exports = __webpack_public_path__ + "media/assets/faria_products/PEA-ADV-ec63fd3119e37f708937bfdbb2abd18464e040181bb10b5437d4fd390a5d5b74.png";